import { render, staticRenderFns } from "./HistoryImport.vue?vue&type=template&id=67f37a1e&"
import script from "./HistoryImport.vue?vue&type=script&lang=js&"
export * from "./HistoryImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports